// import axios from "@/axios"; 
import axiosSync from "@/axiosSync";
// import axios from "@/axios";

export function usePortInfoBdComGponApi() {
  async function getBasicInfo(olt_id) {
    const response = await axiosSync.get(`/bdcom-gpon?oltid=${olt_id}&types=systeminfo&url=${process.env.VUE_APP_API_BASE_URL}`);
    return response.data;
  }
  async function getPortData(olt_id) {
    const response = await axiosSync.get(`/bdcom-gpon?oltid=${olt_id}&types=portstatus&url=${process.env.VUE_APP_API_BASE_URL}`);
    return response.data;
  }
  async function getPonPortData(olt_id) {
    const response = await axiosSync.get(`/bdcom-gpon?oltid=${olt_id}&types=ponport_status&url=${process.env.VUE_APP_API_BASE_URL}`);
    return response.data;
  }
  async function getUpLinkData(olt_id) {
    const response = await axiosSync.get(`/bdcom-gpon?oltid=${olt_id}&types=uplinkportstatus&url=${process.env.VUE_APP_API_BASE_URL}`);
    return response.data;
  }

  return {    
    getBasicInfo,
    getPortData,
    getPonPortData,
    getUpLinkData,
  };
}
